import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuLayoutSelector} from '@Components/contextual-menu/components/contextual-menu-layout-selector';
import {LayoutOptions} from '@Components/contextual-menu/components/contextual-menu-layout-button';
import type {LayoutTypes} from '@PosterWhiteboard/items/layouts/layout.types';
import {TABLE_LAYOUTS} from '@PosterWhiteboard/items/table-item/table-item.class';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTableItem} from '@Hooks/poster-editor/useGetKeyFromTableItem';

interface TableLayoutSelectorProps {
  isMobileVersion?: boolean;
}

export function TableLayoutSelector({isMobileVersion = false}: TableLayoutSelectorProps): ReactElement | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const itemLayoutStyle = useGetKeyFromTableItem('layoutStyle');

  if ((activeItem && !activeItem.isSchedule()) || itemLayoutStyle === undefined) {
    return null;
  }

  if (!activeItem || (activeItem && !('layoutStyle' in activeItem))) {
    throw new Error(`Item doesn't have layoutStyle property`);
  }

  const onClickHandler = (layoutStyle: string): void => {
    activeItem.updateTableLayout(layoutStyle as LayoutTypes);
  };

  return (
    <ContextualMenuLayoutSelector
      isMobileVersion={isMobileVersion}
      layoutFor={LayoutOptions.SCHEDULE}
      selectedLayoutId={itemLayoutStyle}
      layoutNames={TABLE_LAYOUTS}
      onClick={onClickHandler}
    />
  );
}
